const digitsRE = /(\d{3})(?=\d)/g

export function currency (value, currency, decimals) {
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return '0'  
  currency = currency == 'CNY' ? '¥' : currency == null ? '' : currency
  decimals = decimals != null ? decimals : 0
  var stringified = Math.abs(value).toFixed(decimals)
  var _int = decimals
    ? stringified.slice(0, -1 - decimals)
    : stringified
  var i = _int.length % 3
  var head = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
    : ''
  var _float = decimals
    ? stringified.slice(-1 - decimals)
    : ''
  var sign = value < 0 ? '-' : ''
  return currency !== '%' ? currency + ' ' + sign + head +
    _int.slice(i).replace(digitsRE, '$1,') +
    _float : sign + head +
    _int.slice(i).replace(digitsRE, '$1,') +
    _float + ' ' + currency
}
